import {SvgIcon, useTheme} from '@mui/material';

export default function AddIcon() {
	const theme = useTheme();
	// @ts-ignore
	const color = theme.palette.primary[600];
	return (
		<SvgIcon width="24" height="24" viewBox="0 0 24 24" fill="none">
			<g id="vuesax/linear/add">
				<g id="vuesax/linear/search-zoom-in">
					<g id="search-zoom-in">
						<path id="Vector" d="M9 12H15" stroke={color} stroke-width="1.5" stroke-linecap="round"
						      stroke-linejoin="round"/>
						<path id="Vector_2" d="M12 15V9" stroke={color} stroke-width="1.5" stroke-linecap="round"
						      stroke-linejoin="round"/>
						<path id="Vector_3"
						      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
						      stroke={color} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
					</g>
				</g>
			</g>
		</SvgIcon>
	);
}
